import { Pipe, PipeTransform } from '@angular/core';
import { CIVILITIES_OPTIONS } from 'models/enums/civilities-option.enum';

@Pipe({
  name: 'civilityName',
  standalone: true,
})
export class CivilityNamePipe implements PipeTransform {
  private readonly CIVILITIES_OPTIONS = CIVILITIES_OPTIONS;

  transform(value?: string | null): string {
    if (value) {
      return this.CIVILITIES_OPTIONS.find(it => it.value === value)?.label ?? '';
    }
    return value ?? '';
  }
}
